import type { IdTokenResult } from 'firebase/auth';
import type { DecodedIdToken } from 'firebase-admin/auth';

import { mergeRoles, type GlobalRole } from '@/lib/auth/roles';

export type AppRoleClaims = {
  admin?: boolean;
  owner?: boolean;
};

type AnyClaimsLike = Partial<AppRoleClaims> | IdTokenResult['claims'] | DecodedIdToken | null | undefined;

export function rolesFromClaims(claims: AnyClaimsLike): GlobalRole[] {
  if (!claims) return [];
  const roles: GlobalRole[] = [];
  if (claims.admin || claims.owner) roles.push('admin');
  if (claims.owner) roles.push('owner');
  return roles;
}

export function mergeRolesWithClaims(profileRoles: GlobalRole[] | undefined, claims: AnyClaimsLike) {
  const safeProfileRoles = (profileRoles ?? []).filter((role) => role !== 'admin' && role !== 'owner');
  return mergeRoles(safeProfileRoles, rolesFromClaims(claims), ['reader']);
}

export function claimsCanAccessAdmin(claims: AnyClaimsLike) {
  return rolesFromClaims(claims).some((role) => role === 'admin' || role === 'owner');
}

export function buildRoleClaims(params: {
  existingClaims?: Record<string, unknown> | null;
  makeAdmin: boolean;
  makeOwner: boolean;
}) {
  const nextClaims = { ...(params.existingClaims ?? {}) } as Record<string, unknown>;

  if (params.makeOwner) {
    nextClaims.owner = true;
    nextClaims.admin = true;
  } else {
    delete nextClaims.owner;
    if (params.makeAdmin) {
      nextClaims.admin = true;
    } else {
      delete nextClaims.admin;
    }
  }

  return nextClaims;
}
